<template lang="pug">
  section.home
    Jumbo
    .content
      .block
        p.paragraph-dropcap La marca MG vive un buen momento en Chile y las cifras avalan esta sensación de satisfacción entre los ejecutivos de SKBergé, representante de la marca china en nuestro país. "Hoy acumulamos un crecimiento de 70% y esperamos terminar este año con 5.600 unidades vendidas -2.200 vehículos más que en 2017-, lo que representa un market share de 1,4%, creciendo 0,5 puntos porcentuales en comparación al año pasado. A eso debemos agregar que el crecimiento de MG en el norte de Chile alcanza un 120% y en el sur es de 150%, lo que nos pone muy contentos", explica Rodrigo González, gerente general de MG Motor Chile, quien agrega que "la llegada del nuevo MG 3, por supuesto que fortalece nuestra gama y nos pone aún más optimistas de lo que podemos lograr".

      .block-wide
        VideoBlock(iframe='<iframe id="vrudo" class="vrudo" src="//rudo.video/vod/bG0pSL/autostart/false" width="560" height="315" allowscriptaccess="always" allowfullscreen="true" webkitallowfullscreen="true" frameborder="0" scrolling="no" allow="autoplay; fullscreen" ></iframe>')

      .block
        p Desde su lanzamiento en Chile en 2012, el MG 3 solo ha traído alegrías para la marca, posicionándose entre los jóvenes desde su comienzo y ganando ese mismo año el premio "Mejor Auto de Valor", galardón entregado por la prensa especializada chilena. Así, el hatchback compacto construido en China ha comercializado más de 9.000 unidades, transformándose en el top sale de la firma en nuestro país.

      .block-wide
        Imagen(src="content/2019MG3-01.jpg", caption="El MG 3 2019, modelo inglés.")

      .block
        p Por eso, la llegada de la segunda generación viene cargada de optimismo y las expectativas de los ejecutivos con ella son altas. El importador espera vender 3.000 unidades anuales, unas 800 más de lo que estaban vendiendo con la actual generación. "Tenemos un gran producto", sentencia González.

      .block-special
        .text
          h3 El exterior
          p Un frontal más robusto, con una grilla de panal de abeja con el logo en el centro, focos más alargados y un faldón delantero que integra los neblineros y la entrada de aire.

        Imagen(src="content/2019MG3-02.jpg", caption="El frontal. Modelo Inglés.")

      .block
        h3 Cambios sustanciales
        p La segunda generación del MG 3 mantiene casi inalterables sus dimensiones, excepto en el largo, que ahora pasa a 4.055 mm.

        p Los cambios vienen por su profundo rediseño, con un frontal más robusto, con una grilla de panal de abeja con el logo en el centro, focos más alargados y un faldón delantero que integra los neblineros y la entrada de aire. El capó en el lateral viene con marcadas nervaduras, los espejos son del color negro (a diferencia de lo que sale en las fotos), mientras que en la zaga los focos son alargados.

      .block-special
        .text
          h3 El interior
          p La incorporación de un volante deportivo, a lo que se suman nuevos materiales y mejoras importantes en las terminaciones, elevando su calidad percibida.

        Imagen(src="content/2019MG3-04.jpg", caption="El volante deportivo. Modelo Inglés")

      .block
        p En el interior, los cambios son aún más visibles, con otra disposición de los elementos, la incorporación de un volante deportivo, a lo que se suman nuevos materiales y mejoras importantes en las terminaciones, elevando su calidad percibida.

        p El MG 3 equipa la nueva línea de motores NetBlue, más eficientes y con mejor consumo. El bloque de 1,5 litros podrá estar asociado a una caja manual de cinco marchas (105 Hp y 135 Nm) y por primera vez a una automática de cuatro cambios (110 Hp y 150 Nm).

      .block-wide
        Imagen(src="content/2019MG3-03.jpg", caption="El MG 3 en todo su esplandor. Modelo Inglés")

      .block
        p Habrá dos versiones de equipamiento. De serie (Standard) viene con doble airbag (obligatorios), llantas de 15'', radio con bluetooth y entrada USB, frenos ABS con EBD, sensor de retroceso, aire acondicionado y volante regulable en altura. La versión tope  (Comfort) agrega llantas bicolor de 16'', pantalla táctil de 8'' con Apple CarPlay, cuatro airbags, controles de radio al volante, luces diurnas led, monitoreo de presión de neumático, neblineros, spoiler, cámara de retroceso y aire acondicionado digital. El MG 3 se ve moderno por dentro y por fuera. En el interior llaman la atención los nuevos materiales empleados y su buen nivel de terminaciones. Los precios del modelo van desde los $ 6.990.000 hasta los $ 8.790.000.
    ViewMore
</template>

<script>
import Jumbo from '@/components/Jumbo'
import Imagen from '@/components/Imagen'
import ViewMore from '@/components/ViewMore'
import VideoBlock from '@/components/VideoBlock'

export default {
  components: {
    Jumbo,
    Imagen,
    ViewMore,
    VideoBlock
  }
}
</script>
<style lang="scss" scoped>
  .content{
    padding: 4rem 1rem;
  }
  .block{
    max-width: $maxwidth;
    margin: 0 auto;
    padding: 1rem 0;
  }
  .block-wide{
    max-width: $overwidth;
    margin: 0 auto;
    padding: 1rem 0;
  }
  .paragraph-dropcap{
    text-indent: 0;
    &:first-letter {
      float: left;
      text-transform: uppercase;
      font-weight: 900;
      font-family: 'cap', sans-serif;
      font-size: 640%;
      text-transform: uppercase;
      line-height: 90%;
      padding-right: 8px;
      margin-left: -6px;
    }
  }

  .block-special{
    max-width: $uberwidth;
    margin: 0 auto;
    position: relative;
    .text{
      position: absolute;
      bottom: 0;
      right: 0;
      max-width: 33%;
      background-color: rgba(0,0,0,0.6);
      color: white;
      padding: 2rem;
      text-align: right;
      @media (max-width: 800px){
        max-width: none;
      }
      h3{
        font-weight: 600;
        line-height: 100%;
        letter-spacing: -3px;
        font-family: 'col', sans-serif;
        text-shadow: 1px 1px 1px black;
        @include fluid-type(360px,
          1440px,
          48px,
          72px);
        color: white;
      }
    }
  }
</style>

